const FinnstepLead = {
    name: "Finnstep",
    bpm: 104,
    signature: "2/4",
    introMeasures: 16,
    pattern: [

    ]
};

export default FinnstepLead;